import { Injectable, signal } from '@angular/core';
import { Toast, ToastType } from '../interfaces/toast.interface';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private toastsSignal = signal<Toast[]>([]);
  public toasts = this.toastsSignal.asReadonly();

  private generateId(): string {
    return Math.random().toString(36).substring(2) + Date.now().toString(36);
  }

  show(message: string, type: ToastType = 'info', options?: Partial<Toast>): void {
    const toast: Toast = {
      id: this.generateId(),
      message,
      type,
      duration: 5000,
      dismissible: true,
      ...options
    };

    this.toastsSignal.update(toasts => [...toasts, toast]);

    if (toast.duration && toast.duration > 0) {
      setTimeout(() => {
        this.dismiss(toast.id);
      }, toast.duration);
    }
  }

  success(message: string, options?: Partial<Toast>): void {
    this.show(message, 'success', { icon: 'heroCheckCircle', ...options });
  }

  error(message: string, options?: Partial<Toast>): void {
    this.show(message, 'error', { icon: 'heroXCircle', ...options });
  }

  warning(message: string, options?: Partial<Toast>): void {
    this.show(message, 'warning', { icon: 'heroExclamationTriangle', ...options });
  }

  info(message: string, options?: Partial<Toast>): void {
    this.show(message, 'info', { icon: 'heroInformationCircle', ...options });
  }

  dismiss(id: string): void {
    this.toastsSignal.update(toasts => toasts.filter(toast => toast.id !== id));
  }

  clear(): void {
    this.toastsSignal.set([]);
  }
}